import {  Component, Input, OnChanges, OnInit, OnDestroy } from '@angular/core';
import { Store } from '@ngxs/store';
import { BaseSharedState } from '../../store/base.state';
import { RDMClientService } from '../../services/rdm-client.service';
import { Observable, Subject } from 'rxjs';
import { takeUntil, filter } from 'rxjs/operators';

@Component({
  selector: 'app-code-label',
  templateUrl: './code-label.component.html',
})
export class CodeToLabelComponent implements OnInit, OnChanges, OnDestroy {
    private destroy$ = new Subject<void>();
    @Input() code: string;
    @Input() refType: string;
    data :any= {
      label: null
    };
    rdmData$: Observable<any>;
    constructor(private rdmClientService: RDMClientService, private store: Store) {
      this.rdmData$ = this.store.select(BaseSharedState.getRdmData);
    }

    ngOnChanges(): void {
      this.convertCodeToLabel();
    }

    ngOnInit() {
      if (this.rdmData$) {
        this.rdmData$
          .pipe(
            takeUntil(this.destroy$),
            filter(rdmArr => rdmArr != null)
          )
          .subscribe((rdmArr) => {
            const arr = rdmArr.get(this.refType);
            if (arr && arr.length > 0) {
              arr.forEach((element: { code: string; label:null; }) => {
                if (element.code === this.code) {
                  this.data.label = element.label
                }
              });
            }
          });
      }
      this.convertCodeToLabel();
    }

    ngOnDestroy() {
      this.destroy$.next();
      this.destroy$.complete();
    }

    convertCodeToLabel() {
      if (this.code) {
        const list = this.rdmClientService.getRefValues(this.refType);
        const value = this.rdmClientService.getRefValueByCode(list, this.code);
        this.data.label = value ? value.label : null;
      }
    }
}
